import React from 'react';
import EventListener from 'react-event-listener';

import DataList from './DataList';

const Suggestions = ({onClick, onKeyUp, ...props}) => (
    <EventListener target={window} onClick={onClick} onKeyUp={onKeyUp}>
        <DataList {...props} />
    </EventListener>
);

export default Suggestions;
